"use client";
import React, { useState, useEffect } from "react";
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from "react-places-autocomplete";
import { Icon } from "semantic-ui-react";
import { formattedCityName } from "../../../common/Utils";

export default function CitySearchBar({
  value = "",
  onCitySelect,
  rankingType,
  page,
}) {
  const [city, setCity] = useState(value);

  // Keep defaultCity in sync if parent changes it
  useEffect(() => {
    if (value) {
      setCity(value);
    }
  }, [value]);

  const handleChange = (val) => setCity(val);

  const handleSelect = async (description) => {
    setCity(description);

    const parts = description.split(",");
    const cityname = parts[0]?.trim();
    const statename = parts[1]?.trim();

    if (cityname && statename) {
      if (page === "cityranking") {
        window.location.href = `/Cityranking/best-${rankingType}/${formattedCityName(
          cityname,
        )}-${statename}`;
      } else {
        window.location.href = `/Nhranking/best-${rankingType}/${formattedCityName(
          cityname,
        )}-${statename}`;
      }
    }
  };

  return (
    <PlacesAutocomplete
      value={city}
      onChange={handleChange}
      onSelect={handleSelect}
      shouldFetchSuggestions={city.length > 1}
      searchOptions={{ types: ["(cities)"] }} // restrict to cities only
    >
      {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
        <div style={{ position: "relative", width: "100%" }}>
          {/* Input */}
          <div
            className="ui large left icon input location-search-input"
            style={{ width: "100%" }}
          >
            <input
              {...getInputProps({
                placeholder: "Enter city",
              })}
              style={{
                width: "100%",
                borderRadius: "0px",
                fontSize: "15px",
                fontWeight: "bold",
              }}
            />
            <i aria-hidden="true" className="search icon"></i>
          </div>

          {/* Dropdown */}
          {suggestions.length > 0 && (
            <div
              className="autocomplete-dropdown-container"
              style={{
                width: "100%",
                position: "absolute",
                top: "42px",
                backgroundColor: "#fff",
                border: "1px solid rgb(200,200,200)",
                borderTop: "none",
                zIndex: 999,
                borderRadius: "0 0 4px 4px",
                textAlign: "left",
              }}
            >
              {loading && <div style={{ padding: "8px 16px" }}>Loading...</div>}

              <div className="nh_search" style={{ padding: "6px 16px" }}>
                <Icon name="building" /> City
              </div>

              {suggestions.map((s, idx) => {
                const props = getSuggestionItemProps(s, {
                  style: {
                    cursor: "pointer",
                    padding: "8px 16px",
                    backgroundColor: s.active ? "#1b57a5" : "#fff",
                    color: s.active ? "#fff" : "#000",
                  },
                  className: city === s.description ? "suggestion-active" : "",
                  onClick: () => handleSelect(s.description),
                });
                return (
                  <div key={idx} {...props}>
                    {s.description}
                  </div>
                );
              })}
            </div>
          )}
        </div>
      )}
    </PlacesAutocomplete>
  );
}
